import React, { useState, useEffect } from "react";
import { API_URL } from "../constants";
import "./admin.css";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

export default function EditUserForm({ id, rafraichir, token }) {
  const [newUser, setNewUser] = useState({ mail: "" });
  const [messageMailInvalide, setMessageMailInvalide] = useState("");
  const [messageUpdateMail, setMessageUpdateMail] = useState("");
  const navigate = useNavigate();

  const showMessagePopup = (message) => alert(message);

  const clearMessages = () => {
    setTimeout(() => {
      setMessageMailInvalide("");
      setMessageUpdateMail("");
    }, 5000);
  };

  useEffect(() => { clearMessages(); }, [messageMailInvalide, messageUpdateMail]);

  const handleChange = (event) => {
    setNewUser({ ...newUser, [event.target.name]: event.target.value });
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!validateEmail(newUser.mail)) {
      setMessageMailInvalide("Adresse e-mail invalide");
      return;
    }

    axios.patch(
      `${API_URL}/users/${id}`,
      { mail: newUser.mail },
      { headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: "Bearer " + token } }
    )
      .then((response) => {
        if (response.status === 401) {
          showMessagePopup("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
          localStorage.clear();
          navigate.push("/login");
        } else {
          return response.data.data;
        }
      })
      .then(
        () => { setMessageUpdateMail("Mail mis à jour !"); rafraichir(); window.location.reload(); },
        (error) => console.log(error)
      );
  };

  useEffect(() => {
    axios.get(`${API_URL}/users?limit=1000&offset=0`, {
      headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: "Bearer " + token }
    })
      .then((response) => {
        const selectedUser = response.data.data.find((user) => user.id === id);
        if (selectedUser) setNewUser({ mail: selectedUser.mail || "" });
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          showMessagePopup("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
          localStorage.clear();
          navigate("/login");
        }
      });
  }, [id, token, navigate]);

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-3">
      <input
        className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm bg-gray-50 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition"
        onChange={handleChange}
        value={newUser.mail}
        placeholder="Nouvelle adresse e-mail"
        name="mail"
        type="email"
      />
      <input
        type="submit"
        value="Mettre à jour"
        className="w-full bg-loginBordure hover:bg-blue-900 text-white text-sm font-semibold py-2.5 rounded-xl transition-all duration-200 cursor-pointer border-none"
      />
      {messageMailInvalide && (
        <div className="flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 rounded-xl px-3 py-2 text-sm font-medium">
          <span className="w-2 h-2 rounded-full bg-red-500 shrink-0" />
          {messageMailInvalide}
        </div>
      )}
      {messageUpdateMail && (
        <div className="flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 rounded-xl px-3 py-2 text-sm font-medium">
          <span className="w-2 h-2 rounded-full bg-emerald-500 shrink-0" />
          {messageUpdateMail}
        </div>
      )}
    </form>
  );
}